import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton } from "@hydrologiq/shared/content/components/Button"
import { Text } from "@chakra-ui/react"

interface DeleteBlockedDialogProps {
  open: boolean
  onClose: () => void
}

/**
 * DeleteBlockedDialog - Informational dialog shown when a user attempts to delete
 * a data connector that is currently associated with one or more systems.
 *
 * Displays a blocking message and a dismiss button. No delete action is possible.
 */
export function DeleteBlockedDialog({ open, onClose }: DeleteBlockedDialogProps) {
  return (
    <Dialog
      title="Cannot delete connector"
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose()
      }}
      footer={
        <ActionButton
          onClick={onClose}
          context={{
            label: "OK",
            description: "Dismiss this dialog",
            variant: "primary",
          }}
        />
      }
    >
      <Text>
        This data connector cannot be deleted because it is currently used by one or more systems.
      </Text>
    </Dialog>
  )
}

export default DeleteBlockedDialog
